import type { StoredSecurityAssessment } from "../src/security-assessment";

export const securityAssessmentCache = new Map<string, { value: StoredSecurityAssessment; unsynced: boolean }>();
export const clearSecurityAssessmentCache = () => securityAssessmentCache.clear();
